/** Use HTTP auth-verify API instead of direct RTDB PIN paths (login flow). */
export function isAuthVerifyApiEnabled(): boolean {
  const raw = String(process.env.VUE_APP_AUTH_VERIFY_API || "").toLowerCase();
  return raw === "on" || raw === "1" || raw === "true";
}
